import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Popconfirm, Table, Form } from "antd";
import FetchSelect from "Components/fetch-select";
import { DISPLAY_MODE } from "Constants";
import React, { useEffect, useState } from "react";
import { Controller, useFieldArray } from "react-hook-form";

export default function MeasureList({
  form,
  mode = DISPLAY_MODE.EDIT,
  ...props
}) {
  const { fields: measures, append, remove } = useFieldArray({
    control: form.control,
    name: "measures",
  });

  const errors = form.errors;
  const watch = form.watch;

  const [selectedMeasuresList, setSelectedMeasuresList] = useState([]);

  const { measures_ } = watch(["measures"]);

  useEffect(() => {
    let measuresList = form.getValues().measures;
    if (!Array.isArray(measuresList)) return;
    let excludedList = [];
    measuresList.forEach((measure) => {
      if (measure.measurementType?.id)
        excludedList.push(measure.measurementType.id);
    });

    setSelectedMeasuresList(excludedList);
  }, [form]);

  const columns = [
    {
      title: "Ölçü Birimi",
      dataIndex: ["measures", "id"],
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.measures && errors.measures[index]?.measures?.id && "error"
            }
          >
            <FetchSelect
              api="/masterdata/measurementtypes"
              form={form}
              excludedOptions={selectedMeasuresList}
              field={`measures[${index}].measurementType`}
              placeholder="Ölçü Birimi"
              readOnly={mode === DISPLAY_MODE.READ_ONLY}
            />
          </Form.Item>
        );
      },
    },

    {
      title: "Değer",
      dataIndex: "measureValue",
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.measures && errors.measures[index]?.measureValue && "error"
            }
          >
            <Controller
              control={form.control}
              name={`measures[${index}].measureValue`}
              as={
                <Input
                  placeholder="Değer"
                  readOnly={mode === DISPLAY_MODE.READ_ONLY}
                />
              }
            />
          </Form.Item>
        );
      },
    },
    {
      title: "İşlemler",
      dataIndex: "operation",
      width: 100,
      fixed: "right",
      render: (text, record, index) => {
        return (
          <>
            {/* useArrayField yapılarında, itemdaki değişikliği gönderebilmek için hidden bir input
                alanında Id değerini tutmak ve formOnSubmitde bu idyi kullanarak nesneleri mergelemeliyiz*/}
            <Controller
              control={form.control}
              name={`measures[${index}].id`}
              as={<Input type="hidden" />}
            />
            <Popconfirm
              title="Emin Misin?"
              onConfirm={() => remove(index)}
              icon={<FontAwesomeIcon icon={["far", "trash-alt"]} />}
              okText="Kaldır"
              cancelText="Geri"
            >
              <Button type="danger" disabled={mode === DISPLAY_MODE.READ_ONLY}>
                <FontAwesomeIcon icon={["far", "trash-alt"]} />
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];

  return (
    <Table
      size="small"
      scroll={{ x: 300, y: 300 }}
      bordered
      rowKey={(row) => row.id}
      title={() => {
        return (
          <Button
            key="add"
            disabled={mode === DISPLAY_MODE.READ_ONLY}
            onClick={() => {
              append({});
            }}
          >
            <FontAwesomeIcon icon={["fas", "plus"]} />
          </Button>
        );
      }}
      dataSource={measures}
      columns={columns}
    />
  );
}
